

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import GradientHexagon from '~/components/UIComponents/GradientHexagon.vue';

@Component({ components: { GradientHexagon } })
export default class LockedAccountIcon extends Vue {
  @Prop({ type: String, default: '80px' }) readonly width!: string;

  userIcon = require('@/assets/icons/icon_user_white.png');

  get lockSize() {
    const regEx = /(?<num>\d+)(?<str>\w+)/;
    const separatedWidthVals = this.width.match(regEx)?.groups;
    if (
      separatedWidthVals &&
      separatedWidthVals.num &&
      separatedWidthVals.str
    ) {
      return `${+separatedWidthVals.num * 0.25}${separatedWidthVals.str}`;
    }
    return '2em';
  }
}
